import { AfterViewChecked, AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, QueryList, SimpleChanges, ViewChild, ViewChildren, ViewContainerRef } from '@angular/core';
import { MAX_PLAYLIST_TIME, roundNumber, TIMELINE_SCALE_LONG, TIMELINE_GRID_H2 } from "../../../common";
import { ToastrService } from "ngx-toastr";
import { TranslocoService } from "@ngneat/transloco";
import { MatMenuTrigger } from '@angular/material/menu';
import { faCut, faCopy, faPaste } from "@fortawesome/free-solid-svg-icons";
import { StoreSelectorsService } from "../../../services";
import { actionSceneItemPlaylist } from "../../../store/actions/user.actions";
import { Memoizee } from "../../../decorators/memoizee-decorator";
import { ScenePreviewComponent } from '../scene-preview/scene-preview.component'
import { Id } from '../../../interfaces';

declare let jQuery: any;
declare let Draggable: any;
declare let TweenLite: any;

@Component({
    selector: 'app-playlist-timeline',
    templateUrl: './playlist-timeline.component.html',
    styleUrls: ['./playlist-timeline.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PlaylistTimelineComponent implements OnInit, OnChanges, AfterViewInit, AfterViewChecked, OnDestroy {
    @ViewChild(MatMenuTrigger) contextMenu: MatMenuTrigger;
    @ViewChildren('previewContainer', { read: ViewContainerRef }) containers: QueryList<ViewContainerRef>;

    readonly faCut = faCut;
    readonly faCopy = faCopy;
    readonly faPaste = faPaste;
    readonly timelineScale = TIMELINE_SCALE_LONG;
    readonly timelineH = TIMELINE_GRID_H2;
    readonly timelineWidthDiff = 2000;

    $container;
    timeLineState;
    draggingItem;
    scrollPosition = 0;
    totalItems = 0;
    isRendering = false;
    subs;
    selectedIndexes: Array<number> = [];
    activeChannel;
    selectedItems = [];
    contextMenuPosition = { x: '0px', y: '0px' };
    rulerWidthList: any[] = [];
    scenePreviewContainers = {};

    @Input() zoom = 1;
    @Input() scenePreviewEnabled = false;
    @Input()
    set setTimeLineState(i_timeLineState) {
        this.timeLineState = i_timeLineState;
        this.totalItems = i_timeLineState.items.length;
    }

    @Output() moveItems = new EventEmitter<any>();
    @Output() resizeItems = new EventEmitter<any>();
    @Output() clickChannel = new EventEmitter<any>();
    @Output() pastePages = new EventEmitter<any>();
    @Output() jumpToPlayer = new EventEmitter<any>();

    constructor(
        private cd: ChangeDetectorRef,
        private toastr: ToastrService,
        private translocoService: TranslocoService,
        private storeSelector: StoreSelectorsService,
    ) {
    }

    @HostListener('document:contextmenu', ['$event'])
    onContextmenu(event) {
        if (this.contextMenu.menuOpen) {
            event.preventDefault();
            event.stopPropagation();
            this.contextMenu.closeMenu();
        }
    }

    ngOnInit() {
        // reset item selection when the container is clicked
        this.subs = this.storeSelector.listenSelectedScenePlaylist().subscribe((v) => {
            this.selectedIndexes = v;
            this.selectItemsByIndexes(v);
        });

        // this.cod(
        //     this.storeSelector.getLocalStoreUpdates('ILocalStorageConfig').pipe(filter((v) => v !== null))
        //         .subscribe((e) => {
        //             const t = this.localStoreService.getStorageValConfig('sceneCheckeredBackground');
        //             if (t === this.sceneCheckeredBackground) return;
        //             this.sceneCheckeredBackground = t;
        //             this.cd.markForCheck();
        //         })
        // );

        // this.$container.click((e) => {
        //     if (!jQuery(e.target).hasClass('box') && !jQuery(e.target).hasClass('box-image') && !jQuery(e.target).hasClass('item-preview') &&
        //         !jQuery(e.target).hasClass('item-title') && !jQuery(e.target).hasClass('li-item') && !jQuery(e.target).hasClass('mat-icon')) {
        //         this.resetItemsSelection();
        //         this.initializeSelection();
        //     }
        // });
    }

    ngOnChanges(changes: SimpleChanges) {
        // ngOnChanges gets called first, so initialize here
        this.$container = jQuery('#playlistContainer');
        // this.timeLineState = Object.assign({}, this.defaultState, this.timeLineState.toJS());

        this.initializeStateChanges();

        if (changes.zoom && changes.zoom.currentValue != this.timeLineState.zoom) {
            this.timeLineState.zoom = changes.zoom.currentValue;
            if (!changes.zoom.isFirstChange()) {
                this.changeZoom(null);
            }
        }
        this.rulerWidthList = this.getRulerWidth();
        this.isRendering = true;
        this.cd.detectChanges();
    }

    ngAfterViewInit(): void {
        // this.loadChildPreviews();
    }

    ngAfterViewChecked(): void {
        if (this.isRendering) {
            this.setChannelActions();
            this.isRendering = false;
        }
    }

    @Memoizee({})
    loadChildPreview(sceneId: Id, container: ViewContainerRef) {
        container.clear();        
        const componentRef = container.createComponent(ScenePreviewComponent);
        
        componentRef.instance.previewHeight = 60;
        componentRef.instance.autoScale = true;
        componentRef.instance.setSelectedSceneId = sceneId;
    }

    loadChildPreviews() {
        if (!this.containers || this.containers.length === 0) return;

        this.containers.forEach((container, index) => {
            const item = this.timeLineState.items[index];
            if (item.pageType === 'scene') {
                this.loadChildPreview(item.pageSrc, container);
                this.scenePreviewContainers[item.pageSrc] = container;
            }
        });
        this.cd.detectChanges();
    }
    
    setChannelActions() {
        setTimeout(() => {
            this.initializeDraggle();
            this.initializeResizable();
            this.loadChildPreviews();

            // this.applyItemBounds();
        });

    }

    private initializeStateChanges() {
        // draw channels
        this.drawChannels();

        // initialize item positions
        this.timeLineState.items.forEach((item) => {
            const ch = this.timeLineState.channels[item.channel];
            if (!ch) return;
            item.left = item.start * (this.timelineScale / this.timeLineState.zoom);
            item.width = item.duration * (this.timelineScale / this.timeLineState.zoom);
            item.top = ch.top;
            item.overlapsLeft = [];
            item.overlapsRight = [];
            item.selected = this.selectedIndexes && ch.selected ? this.selectedIndexes.indexOf(ch.pageIndexes.indexOf(item.pageId)) > -1 : false;
        });
        this.activeChannel = this.timeLineState.channels.filter((channel) => channel.selected == true)[0];
        this.setSelectedItems();
    }

    onScroll(e) {
    }

    private initializeDraggle() {
        const self = this;
        let startX, startY;
        let group = [];
        let groupDuration = 0;
        let selectedItem;
        let currentTarget;

        Draggable.create('.box.draggable', {
            bounds: self.$container,
            edgeResistance: 1.0,
            type: "x,y",
            throwProps: false,
            lockAxis: false,
            x: 0,
            y: 0,
            liveSnap: {
                y(endValue) {
                    return Math.round(endValue / TIMELINE_GRID_H2) * TIMELINE_GRID_H2;
                },
                x(endValue) {
                    // only allow objects to stop at positions that represent whole numbers of seconds
                    const timeValue = Math.round(endValue * self.timeLineState.zoom / self.timelineScale);
                    return timeValue * (self.timelineScale / self.timeLineState.zoom);
                }
            },
            onPress(e) {
                // console.log("on Press");
                e.stopPropagation();
                currentTarget = e.currentTarget;
                if (e.currentTarget.getAttribute("data-bid") == undefined) {
                    return;
                }
                selectedItem = self.timeLineState.items[e.currentTarget.getAttribute("data-bid")];
                if (!selectedItem) return;

                self.selectChannel(selectedItem.channel, true);
                self.selectItemByClick(selectedItem, e.ctrlKey);

                startX = this.x;
                startY = this.y;

                self.setSelectedItems();

                self.selectItemsOfChannel();
                groupDuration = 0;
                group = [];

                // tslint:disable-next-line
                self.selectedItems.forEach((item) => {
                    group.push({
                        item,
                        x: item.left,
                        y: item.top,
                    });
                    groupDuration += item.duration;
                });

                TweenLite.killTweensOf(".box");
            },
            onRelease(e) {
                // console.log("on release");
                // item.left = this.x;
                // item.start = item.left * self.timeLineState.zoom / self.timelineScale;

                // check max length
                if (selectedItem.top != startY) {
                    const channelLength = self.getChannelLength(this.y);
                    if (channelLength + groupDuration > MAX_PLAYLIST_TIME) {
                        // item.top = this.y;
                        group.forEach((_item) => {
                            _item.item.top = _item.y;
                        });
                        self.showToastOverLength();
                    }
                }

            },
            onDrag(e) {
                // console.log("on drag");
                const deltaX = this.x - startX;
                const deltaY = this.y - startY;

                if (group.length > 1) {
                    group.forEach((_item, index) => {
                        // change other items left/top.
                        // if item is current dragging item, ignore to change left/top of selected item, because it has transform css.
                        self.moveItem(_item.item, _item.x + deltaX, _item.y + deltaY, _item.item.pageId === selectedItem.pageId);
                    });
                }
                self.cd.detectChanges();
            },
            onDragEnd(e) {
                // change left/top of current dragging item
                if (!currentTarget) return;
                const deltaX = this.x - startX;
                const deltaY = this.y - startY;
                currentTarget.style.removeProperty("transform");
                self.moveItem(selectedItem, selectedItem.left + deltaX, selectedItem.top + deltaY);

                // update playlist items
                self.updateItemsChannel();
                self.notifyChannelOfSelectedItem(selectedItem);
                self.moveItems.emit(self.selectedItems);
                if (selectedItem.top != startY) {
                    self.initializeSelection();
                }
            }
        });
    }

    private initializeResizable() {
        const self = this;
        // resize functionality
        let startWidth; // define a start width to calculate deltas for multi-resize
        let resizingItem;
        let resizingGroup = [];

        jQuery('.box.resizable').resizable({
            handles: 'e, w',
            start(event, ui) {
                event.stopPropagation();
                const id = ui.originalElement.data('bid');
                resizingItem = self.timeLineState.items[id];

                startWidth = resizingItem.width;
                resizingGroup = [];
                self.selectedItems.forEach((item) => {
                    resizingGroup.push({
                        item,
                        width: item.width
                    });
                });
            },
            resize(event, ui) {
                // console.log("on resizing");
                // resizingItem.width = ui.size.width;
                if (!resizingItem) {
                    const id = ui.originalElement.data('bid');
                    resizingItem = self.timeLineState.items[id];
                    startWidth = resizingItem.width;
                }
                const widthDelta = ui.size.width - startWidth;

                // move any companions
                resizingGroup.forEach((groupItem) => {
                    if (groupItem.item) {
                        let w = groupItem.width + widthDelta;

                        if (w < self.timelineScale / self.timeLineState.zoom) {
                            w = self.timelineScale / self.timeLineState.zoom;
                        }
                        groupItem.item.width = w;
                        groupItem.item.duration = roundNumber(w * self.timeLineState.zoom / self.timelineScale);
                    }
                });
                // startWidth = resizingItem.width;
                self.cd.detectChanges();
            },
            stop(event, ui) {
                // console.log("on resize stop");

                // resizable modifies the left which messes with things, so we undo it and calculate the offsets
                // resizingItem.duration = roundNumber(ui.size.width * self.timeLineState.zoom / self.timelineScale);
                jQuery(this).css({ left: 0 });

                // self.moveItem(resizingItem, resizingItem.left + left, resizingItem.top);

                const selectedItems = self.selectedItems;
                const diffTotalLength = self.getChannelLength(resizingItem.top) - MAX_PLAYLIST_TIME;
                if (diffTotalLength > 0 && selectedItems.length > 0) {
                    self.showToastOverLength();
                    const diffLength = roundNumber(diffTotalLength / selectedItems.length);
                    selectedItems.forEach((selectedItem) => {
                        selectedItem.duration -= diffLength;
                        if (selectedItem.duration > 0) {
                            selectedItem.duration = 0;
                        }
                    });
                }
                // self.notifySelectedChannelsOfSelectedItems(selectedItems);
                self.resizeItems.emit(selectedItems);

                // self.resizeContainerForItem(resizingItem);
                // self.timelineInit.emit({timelineComponent: self});
            }
        });

        // makes GSAP Draggable avoid clicks on the resize handles
        jQuery('.ui-resizable-handle').attr('data-clickable', true);
    }

    private selectItemByClick(item, isCtrl) {
        if (item.selected == true) {
            return;
        }
        if (!isCtrl || this.activeChannel?.id != item.channel) {
            this.resetItemsSelection();
        }
        item.selected = true;
        this.cd.detectChanges();
        
        // item.$el.addClass('ui-selected');
    }

    private resetItemsSelection() {
        this.timeLineState.items.forEach((item) => {
            item.selected = false;
        });
        this.cd.detectChanges();
    }

    private initializeSelection() {
        this.selectedItems = [];
        this.selectItemsOfChannel();
    }

    getChannelLength(top) {
        let totalLen = 0;
        const channelId = this.getChannelId(top);
        this.timeLineState.items.forEach((_item) => {
            if (_item.channel == channelId) {
                totalLen += _item.duration;
            }
        });
        return totalLen;
    }

    getChannelId(top) {
        const newChannel = this.timeLineState.channels.filter((c) => c.top == top)[0];
        if (newChannel) {
            return newChannel.id;
        } else {
            return '-1';
        }
    }

    drawChannels() {
        this.$container.find(".timeline-row").remove();

        const channelLines = "<div class='channel-line' style='top: 15px;'></div>" +
            "<div class='channel-line' style='top: 30px;'></div>" +
            "<div class='channel-line' style='top: 45px;'></div>" +
            "<div class='channel-line' style='top: 60px;'></div>" +
            "<div class='channel-line' style='top: 75px;'></div>";
        const w = this.timeLineState.duration / this.timeLineState.zoom * this.timelineScale + this.timelineWidthDiff;

        this.timeLineState.channels.forEach((channel, i) => {
            // create element for channel and append it to the container

            channel.top = i * this.timelineH;
            channel.$el = jQuery("<div>" + channelLines + "</div>").css({
                height: this.timelineH - 1,
                top: channel.top,
                left: 0,
                width: w
            }).addClass('timeline-row').appendTo(this.$container);
        });

        // set the container's size to match the grid, and ensure that the box widths/heights reflect the variables above
        this.updateContainerSize();
    }

    changeZoom(e) {
        if (!this.timeLineState) return;
        const zoomFactor = this.timelineScale / this.timeLineState.zoom;
        this.updateContainerSize();
        // this.applyItemBounds();

        this.timeLineState.items.map((item) => {
            item.width = item.duration * zoomFactor;
            this.moveItem(item, item.start * zoomFactor, item.top);
            // this.updateItemChannel(item);
        });
    }

    updateItemsChannel() {
        this.selectedItems.forEach((item) => {
            const newChannel = this.timeLineState.channels.filter((c) => c.top == item.top)[0];
            if (newChannel) {
                item.channel = newChannel.id;
                // this.applyItemBounds();
            }
        });

    }

    moveItem(item, x, y, skipLeftTop = false) {
        if (item) {
            // const t0 = performance.now();
            x = (x === undefined) ? item.left : x;
            y = (y === undefined) ? item.top : y;

            // TweenLite.to(item.$el, dur / 1000, {x, y});
            // item.draggable.update(); // update the draggable position
            if (!skipLeftTop) {
                item.left = x;
                item.top = y;
            }
            item.start = Math.round(x * this.timeLineState.zoom / this.timelineScale);
            // this.updateItemChannel(item);
        }
    }

    selectChannel(i, fromItem = false) {
        if (!fromItem) {
            this.initializeSelection();
        }
        if (this.activeChannel?.id !== i) {
            this.resetChannelsSelection();
            this.activeChannel = this.timeLineState.channels[i];
            this.activeChannel.selected = true;
            this.notifyChannel(this.activeChannel, fromItem);
            this.resetItemsSelection();
        }
    }

    // fromItem marks a channel change that came from selecting an ITEM (page), not from clicking the channel
    // row/header - consumers use it to distinguish (e.g. the all-playlists hand-off only fires on a row click).
    notifyChannel(channel, fromItem = false) {
        // const channel = this.timeLineState.channels[i];
        this.clickChannel.emit({...channel, fromItem});
    }

    notifyChannelOfSelectedItem(item) {
        this.notifyChannel(this.getChannelByKey(item.channel, 'index'), true);
    }

    selectItemsByIndexes(i_indexes = []) {
        if (!i_indexes || !this.timeLineState || !this.activeChannel) {
            return;
        }
        const pageIndexes = i_indexes.map((_index) => this.activeChannel.pageIndexes[_index]);
        const items = [];
        this.timeLineState.items.forEach((item) => {
            if (pageIndexes.indexOf(item.pageId) > -1) {
                item.selected = true;
                // if (item.$el) item.$el.addClass('ui-selected');
                items.push(item);
            } else {
                item.selected = false;
                // if (item.$el) item.$el.removeClass('ui-selected');
            }
        });
        this.cd.detectChanges();
        // this.itemsClicked.emit(items);
    }

    onRightClickChannel(e) {

        const bounds = document.querySelector(".timelineMain > .timelineRow").getBoundingClientRect();
        const positionHeight = e.clientY - bounds.top;
        if (positionHeight > 0 && positionHeight < bounds.height) {
            e.stopPropagation();
            e.preventDefault();

            this.selectChannel(Math.floor(positionHeight / this.timelineH));

            this.contextMenuPosition.x = e.clientX + 'px';
            this.contextMenuPosition.y = e.clientY + 'px';
            this.contextMenu.openMenu();
        }
    }

    onClickPaste() {
        this.pastePages.emit(false);
    }

    @Memoizee({})
    formatDuration(d) {
        // console.log("duration = ", d);
        if (!d) return 0;
        d = Math.floor(d);
        if (d < 60) return `${d}s`;
        if (d < 3600) return `${Math.floor(d / 60)}m ${d % 60}s`;
        return `${Math.floor(d / 3600)}h ${Math.floor(d / 60)}m ${d % 60}s`;
    }

    private selectItemsOfChannel() {
        // this.itemsClicked.emit(items);
        if (this.activeChannel) {
            const pageIndexes = [];
            this.selectedItems.forEach((_item) => {
                pageIndexes.push(this.activeChannel.pageIndexes.indexOf(_item.pageId));
            });
            this.storeSelector.dispatch(actionSceneItemPlaylist({ indexes: pageIndexes }));
        } else {
            this.storeSelector.dispatch(actionSceneItemPlaylist({ indexes: [] }));
        }

    }

    private showToastOverLength() {
        this.toastr.error(this.translocoService.translate('general.tooLong24', {}, this.translocoService.getActiveLang()));
    }

    private updateContainerSize() {
        const w = this.timeLineState.duration / this.timeLineState.zoom * this.timelineScale + this.timelineWidthDiff;
        // w = w < 2000 ? 2000 : w;
        this.timeLineState.gridWidth = w;
        TweenLite.set(
            this.$container, {
            height: this.timeLineState.channels.length * this.timelineH + 1,
            width: w
        }
        );
    }

    private resetChannelsSelection() {
        this.timeLineState.channels.forEach((ch) => {
            ch.selected = false;
        });

    }

    private setSelectedItems() {
        this.selectedItems = this.timeLineState.items.filter((item) => item.selected);
    }

    private getChannelByKey(val, type: 'index' | 'select' | 'playlistId') {
        let ch;
        if (type == 'index') {
            ch = this.timeLineState.channels[val];
        } else if (type == 'select') {
            ch = this.timeLineState.channels.filter((_ch) => _ch.selected == val)[0];
        } else if (type == 'playlistId') {
            ch = this.timeLineState.channels.filter((_ch) => _ch.playlistId == val)[0];
        }
        if (ch) {
            return ch;
        } else {
            return {};
        }
    }

    private getRulerWidth() {
        const rulerWidth = this.timeLineState.duration / this.timeLineState.zoom * this.timelineScale + this.timelineWidthDiff;
        // rulerWidth = rulerWidth < 2000 ? 2000 : rulerWidth;
        const UnitRulerWidth = 10000;
        const res = [];
        const cnt = Math.floor(rulerWidth / UnitRulerWidth);
        for (let i = 0; i <= cnt; i++) {
            res.push({
                pos: i * UnitRulerWidth,
                width: i == cnt ? rulerWidth - cnt * UnitRulerWidth : UnitRulerWidth
            });
        }
        return res;
    }

    ngOnDestroy() {
        if (this.subs) this.subs.unsubscribe();
    }
}
